package com.cybersoftsolution.cybersoftsolutionweb.api


import com.cybersoftsolution.cybersoftsolutionweb.models.Values.IM_SUBSCRIBER_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.SUBSCRIBE_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.UNSUBSCRIBE_ROUTE
import com.cybersoftsolution.futures.base.models.Response
import com.varabyte.kobweb.browser.api
import kotlinx.browser.window
import kotlinx.serialization.json.Json


suspend fun subscribe(email: String): Response<Boolean>? {

    val params : MutableMap<String, Any?> =
        mutableMapOf(
            Pair("email", email),
        )

    return try {
        val request = window.api.tryPost(
            apiPath = SUBSCRIBE_ROUTE + params.buildParams(),
        )

        request?.let {
            Json.decodeFromString<Response<Boolean>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getPost Error: ${e.message}")
        null
    }

}


suspend fun unsubscribe(email: String): Response<Boolean>? {

    val params : MutableMap<String, Any?> =
        mutableMapOf(
            Pair("email", email),
        )

    return try {
        val request = window.api.tryPost(
            apiPath = UNSUBSCRIBE_ROUTE + params.buildParams(),
        )

        request?.let {
            Json.decodeFromString<Response<Boolean>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getPost Error: ${e.message}")
        null
    }

}

suspend fun imSubscriber(email: String): Response<Boolean>? {

    val params : MutableMap<String, Any?> =
        mutableMapOf(
            Pair("email", email),
        )

    return try {
        val request = window.api.tryPost(
            apiPath = IM_SUBSCRIBER_ROUTE + params.buildParams(),
        )

        request?.let {
            Json.decodeFromString<Response<Boolean>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getPost Error: ${e.message}")
        null
    }

}
